var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup3Noti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 148,
    height: 149,
    viewBox: "0 0 148 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 74.5,
    r: 74,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1252_9970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.426 64.3365C124.393 64.3365 124.36 64.3263 124.333 64.3073L79.3366 32.9705C79.1996 32.8756 79.0369 32.8249 78.8703 32.8252C78.7037 32.8255 78.5411 32.8767 78.4045 32.9721L33.7323 64.307C33.6969 64.3318 33.6532 64.3415 33.6107 64.3341C33.5682 64.3266 33.5304 64.3026 33.5056 64.2672C33.4808 64.2319 33.4711 64.1882 33.4785 64.1457C33.486 64.1031 33.51 64.0653 33.5454 64.0406L78.2177 32.7057C78.409 32.5722 78.6365 32.5004 78.8698 32.5C79.103 32.4996 79.3308 32.5706 79.5225 32.7035L124.519 64.0402C124.547 64.06 124.569 64.0884 124.58 64.1212C124.591 64.154 124.592 64.1895 124.581 64.2225C124.571 64.2556 124.55 64.2845 124.522 64.305C124.494 64.3255 124.46 64.3365 124.426 64.3365Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2852 65.4473L78.9148 33.8535L121.868 67.6953L81.1112 91.8564L58.9839 86.8127L36.2852 65.4473Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.101 64.0112H124.068L105.39 71.9868L79.8346 82.8992C79.7348 82.9412 79.6276 82.9631 79.5193 82.9637C79.411 82.9642 79.3036 82.9434 79.2033 82.9024L52.8376 71.9641L33.7007 64.0242L33.6715 64.0112H33.6389C33.337 64.0116 33.0475 64.1317 32.8339 64.3452C32.6204 64.5587 32.5003 64.8482 32.5 65.1501V114.611C32.5003 114.913 32.6204 115.203 32.8339 115.416C33.0475 115.63 33.337 115.75 33.6389 115.75H124.101C124.403 115.75 124.692 115.63 124.906 115.416C125.119 115.203 125.239 114.913 125.24 114.611V65.1501C125.239 64.8482 125.119 64.5587 124.906 64.3452C124.692 64.1317 124.403 64.0116 124.101 64.0112ZM124.914 114.611C124.914 114.827 124.828 115.034 124.676 115.186C124.523 115.339 124.316 115.425 124.101 115.425H33.6389C33.4232 115.425 33.2163 115.339 33.0638 115.186C32.9112 115.034 32.8255 114.827 32.8254 114.611V65.1501C32.8257 64.9398 32.9073 64.7376 33.0531 64.586C33.199 64.4344 33.3978 64.3451 33.608 64.3366L52.8376 72.3155L79.0781 83.2034C79.3621 83.319 79.6804 83.3173 79.9632 83.1986L105.39 72.3399L124.133 64.3366C124.343 64.3457 124.541 64.4353 124.687 64.5868C124.832 64.7383 124.914 64.9401 124.914 65.1501V114.611Z",
    fill: "#3F3D56"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1252_9970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 92.7396,
    height: 83.25,
    fill: "white",
    transform: "translate(32.5 32.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3Noti);
export default __webpack_public_path__ + "static/media/Group 3Noti.ad71ac27c3bee300d5effa2cf14a6b73.svg";
export { ForwardRef as ReactComponent };